import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import config from 'config';
// Assets
import Icon from 'assets/Icon';
// Components
import LogoutTimer from 'components/LogoutTimer';
import Notifications from 'components/Notifications';
// Elements
import Button from 'elements/Button';
// Styles
import styles from './style/footer.module.css';

function Footer() {
  // Router
  const history = useHistory();
  const location = useLocation();
  const goBack = (location.pathname !== '/' && location.pathname !== '/maintenance');
  return (
    <>
      <footer className={`${styles.container} ${goBack ? styles.container_goBack : ''}`}>
        { goBack && (
          <div className={styles.goback}>
            <Button
              btnSize="small"
              btnType="icon"
              elevation="32-4"
              handler={() => history.goBack()}
            >
              <Icon icon="ArrowBack" fill="black" />
            </Button>
          </div>
        )}
        <div className={styles.main}>
          <LogoutTimer time={config.logoutTimer} />
        </div>
      </footer>
      <Notifications />
    </>
  );
}

export default Footer;
